import { useIsIframePreview } from "@circle-react-shared/BuilderUI/Hooks/useIsIframePreview";

export const useCanvasOffsets = () => {
  const isUsingIframe = useIsIframePreview();

  if (isUsingIframe) {
    return { offsetX: 0, offsetY: 0 };
  }

  const canvasCard = document.getElementById("builder-ui-canvas-card");
  if (canvasCard) {
    const canvasRect = canvasCard.getBoundingClientRect();
    return { offsetX: -canvasRect.left, offsetY: -canvasRect.top };
  }

  return { offsetX: 0, offsetY: 0 };
};
